/**
 * - Default: Used for informal content
 * - Warning: Warn about mistakes, fixable errors
 * - Danger: Usually used when something is dangerous, like deletion
 * - Info: Usually used with the "i" icon
 */
export enum TooltipIntent {
  Default = "default",
  Warning = "warning",
  Danger = "danger",
  Info = "info",
}
